const lazyElements = document.querySelectorAll('.lazy');

if (lazyElements.length > 0) {
  import('vanilla-lazyload').then(({ default: LazyLoad }) => {
    window.lazyLoadInstance = new LazyLoad({
      elements_selector: '.lazy',
    });
    window.lazyLoadInstance.update();
  });
}
